import { State } from '@energy-retailer/constants';
import { v4 } from 'uuid';
import { z } from 'zod';
import { fullPropertyAddressSchema } from '../full-property-address-schema';

export const msatDiscoverTransformedParametersSchema = fullPropertyAddressSchema
  .strict()
  .transform((val) => ({
    jurisdictionCode: val.state,
    deliveryPointIdentifier: val.dpid!,
    transactionId: v4(),
  }))
  .transform((val) => new URLSearchParams(val))
  .transform((val) => val.toString());

export type MsatDiscoverTransformedParameters = z.infer<
  typeof msatDiscoverTransformedParametersSchema
>;

export const msatDetailsParametersSchema = z.object({
  nmi: z.string(),
  checksum: z.string().max(1),
});

export const msatDetailsTransformedParametersSchema =
  msatDetailsParametersSchema
    .strict()
    .transform((val) => ({
      ...val,
      transactionId: v4(),
    }))
    .transform((val) => new URLSearchParams(val))
    .transform((val) => val.toString());

export const msatNmiDetailsParametersSchema = z
  .object({
    nmi: z.string().min(10).max(11),
  })
  .transform((value) => ({
    nmi: value.nmi.slice(0, 10),
    checksum: value.nmi.length === 11 ? value.nmi.slice(-1) : undefined,
  }));

export type MsatDetailsTransformedParameters = z.infer<
  typeof msatDetailsTransformedParametersSchema
>;
